'use client'

import { createContext, useContext, useEffect, useMemo, useState } from "react"
import SportsLiveTabs from "./components/tabs_head"
import LiveSportsList from "./components/list"
import LiveStreamView from "./components/liveStream"
import { liveStreamListDummy } from "@/dummy/list"
import LiveSportsFilterTabs from "./components/tabs_filter"

import tumb_0 from "@/public/image/etc/live_banner.png"
import tumb_1 from "@/public/image/etc/live_baseball.png"
import tumb_2 from "@/public/image/etc/live_baseball2.png"
import tumb_3 from "@/public/image/etc/live_basketball.png"
import api from "@/util/api"
import { SportsLiveListType } from "@/type/list"
import Tabs from "@/components/etc/tab"
import { tabsType } from "@/type/page"
import FloatMultiViewSelect from "@/components_mobile/float/multiViewSelect"
import { DeviceContext } from "@/context/deviceContext"
import LiveSportsListPC from "./components/list_pc"
import { useMainScroll } from "@/components/common/main/_main"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import loadingJson from "@/public/media/load_data.json"
import Lottie from "react-lottie-player"
import { tabWhiteList } from "@/type/sports"
import FloatWebShare from "@/components_mobile/float/float_web_share"
import FloatSharePopupMessage from "@/components_mobile/float/share_popup"
import customAlert from "@/util/customAlert"
import { useTranslations } from "next-intl"


export interface shareInfoTypes {
    url: string
    title: string
    description: string
    imageUrl?: string
}
const shareInfoTypesDefault = {
    url: "",
    title: "",
    description: "",
    imageUrl: "",
}
type viewUrlsType = SportsLiveListType[] | any[]
type stremLengType = 1 | 2 | 4
export const LiveStreamContext = createContext<{
    recentUrl: SportsLiveListType | undefined
    set_recentUrl: Function
    stream_1: SportsLiveListType | undefined
    stream_2: SportsLiveListType | undefined
    stream_3: SportsLiveListType | undefined
    stream_4: SportsLiveListType | undefined

    fetchData: Function
    fetchLiveList: Function

    sportsFilterTab: string[]
    setMultiSelectShow: Function,
    AddViewUrl: (url: SportsLiveListType, index: number) => void
    DelViewUrl: (index: number) => void
    streamLen: stremLengType
    setStreamLen: Function

    shareInfo: shareInfoTypes
    setShareInfo: Function
    openWebShare: boolean
    setOpenWebShare: Function
    sharePopupShow: boolean
    setSharePopupShow: Function
}>({
    recentUrl: undefined,
    set_recentUrl: () => { },

    stream_1: undefined,
    stream_2: undefined,
    stream_3: undefined,
    stream_4: undefined,

    fetchData: () => { },
    fetchLiveList: () => { },

    sportsFilterTab: ["",],
    setMultiSelectShow: Function,
    AddViewUrl: () => { },
    DelViewUrl: () => { },
    streamLen: 1,
    setStreamLen: () => { },

    shareInfo: shareInfoTypesDefault,
    setShareInfo: Function,
    openWebShare: false,
    setOpenWebShare: Function,
    sharePopupShow: false,
    setSharePopupShow: Function
})
export type streamTabsType = 'live' | 'multi'
export default function SportsLiveConfig() {
    const { mobileMode } = useContext(DeviceContext)
    const { setScrollTop } = useMainScroll()

    const [liveListDefault, setLiveListDefault] = useState<SportsLiveListType[]>()
    const [sportsFilter, setSportsFilter] = useState<string>('')

    const [recentUrl, set_recentUrl] = useState<SportsLiveListType>()
    const [stream_1, set_stream_1] = useState<SportsLiveListType>()
    const [stream_2, set_stream_2] = useState<SportsLiveListType>()
    const [stream_3, set_stream_3] = useState<SportsLiveListType>()
    const [stream_4, set_stream_4] = useState<SportsLiveListType>()

    const [multiSelectShow, setMultiSelectShow] = useState<boolean>(false)
    const [streamLen, setStreamLen] = useState<stremLengType>(1)

    const [shareInfo, setShareInfo] = useState<shareInfoTypes>(shareInfoTypesDefault)
    const [openWebShare, setOpenWebShare] = useState<boolean>(false)
    const [sharePopupShow, setSharePopupShow] = useState<boolean>(false)

    const [page, setPage] = useState<number>(1)
    const [totalCount, setTotalCount] = useState<number>(1)
    const perPage = 10

    const [mount, setMount] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const router = useRouter()
    const pathName = usePathname()
    const params = useSearchParams()

    const a = useTranslations("Sentence")

    function DelViewUrl(index: number) {
        switch (index) {
            case 1: set_stream_1(undefined); break;
            case 2: set_stream_2(undefined); break;
            case 3: set_stream_3(undefined); break;
            case 4: set_stream_4(undefined); break;
        }
    }
    function AddViewUrl(stream: SportsLiveListType, index: number) {
        // 같은거 있으면 제거
        const streams = [stream_1, stream_2, stream_3, stream_4]
        streams.forEach((el, index) => {
            const streamNum = index + 1
            if (el == stream) {
                DelViewUrl(streamNum)
            }
        })

        switch (index) {
            case 1: set_stream_1(stream); break;
            case 2: set_stream_2(stream); break;
            case 3: set_stream_3(stream); break;
            case 4: set_stream_4(stream); break;
        }
        set_recentUrl(undefined)
    }

    function fetchLiveList() {
        const apiUrl = `/api/live/?page=${page}`
        return api(apiUrl).then(res => res.json())
    }

    function fetchData() {
        const apiUrl = `/api/live/?page=${page}`
        api(apiUrl)
            .then(res => res.json())
            .then(({ data }) => {
                if (data && Array.isArray(data.live)) {
                    const newGetData = (data.live as any[]).map((el) => {
                        return {
                            ...el,
                            sports: tabWhiteList.includes(el.sports) ? el.sports : "ETC",
                        }
                    })

                    // console.log("****", newGetData)
                    setLiveListDefault(newGetData)
                    setTotalCount(data?.total_count ?? 1)
                }
                setLoading(false)
            })
    }

    const liveListFilter: SportsLiveListType[] = useMemo(() => {
        if (!liveListDefault || !liveListDefault.length) return []

        const filterList = sportsFilter ? liveListDefault.filter((el) => el.sports == sportsFilter) : liveListDefault

        return filterList
    }, [liveListDefault, sportsFilter])

    const sportsFilterTab: string[] = useMemo(() => {
        let defaultTab: string[] = [""]
        if (!liveListDefault || !liveListDefault.length) return defaultTab;

        const uniqueSports = Array.from(
            new Set(
                liveListDefault
                    .map(v => (v.sports ?? "").trim())
                    .filter(s => s.length > 0)
            )
        );

        return ["", ...uniqueSports];
    }, [liveListDefault])

    useEffect(() => {
        setMount(true)
        fetchData()
    }, [])

    useEffect(() => {
        if (liveListDefault?.length) {
            const viewCode = params.get('view_code')
            if (viewCode) {
                const findList = liveListDefault.find(el => el.code == viewCode)
                if (findList) {
                    AddViewUrl(findList, 1)
                    // router.push('/sports/live')
                } else {
                    customAlert(a("MatchAlreadyEnded"), 'warning');
                    router.replace(pathName, { scroll: false });
                    setLoading(false)
                }
            }
        }
    }, [liveListDefault])

    /** Scroll */
    useEffect(() => {
        if (stream_1)
            window.scrollTo({ top: 0, behavior: "smooth" })
        setScrollTop()
    }, [stream_1])
    useEffect(() => {
        if (stream_2)
            window.scrollTo({ top: 0, behavior: "smooth" })
        setScrollTop()
    }, [stream_2])
    useEffect(() => {
        if (stream_3)
            window.scrollTo({ top: 0, behavior: "smooth" })
        setScrollTop()
    }, [stream_3])
    useEffect(() => {
        if (stream_4)
            window.scrollTo({ top: 0, behavior: "smooth" })
        setScrollTop()
    }, [stream_4])
    /*************************** */

    useEffect(() => {
        if (streamLen < 3) {
            set_stream_3(undefined)
            set_stream_4(undefined)
        }
        if (streamLen < 2) {
            set_stream_2(undefined)
        }
    }, [streamLen])

    useEffect(() => {
        if (recentUrl) {
            if (mobileMode) {
                if (streamLen > 1) {
                    setMultiSelectShow(true)
                } else {
                    AddViewUrl(recentUrl, 1)
                }
            } else {
                if (!stream_1) {
                    AddViewUrl(recentUrl, 1)
                } else if (!stream_2) {
                    AddViewUrl(recentUrl, 2)
                    if (streamLen == 1) {
                        setStreamLen(2)
                    }
                } else if (!stream_3) {
                    AddViewUrl(recentUrl, 3)
                    setStreamLen(4)
                } else if (!stream_4) {
                    AddViewUrl(recentUrl, 4)
                    setStreamLen(4)
                } else {
                    setMultiSelectShow(true)
                }
            }
        }
    }, [recentUrl])

    const returnValue = {
        recentUrl,
        set_recentUrl,
        stream_1,
        stream_2,
        stream_3,
        stream_4,
        fetchData,
        sportsFilterTab,
        setMultiSelectShow,
        AddViewUrl,
        DelViewUrl,
        streamLen,
        setStreamLen,
        fetchLiveList,

        shareInfo,
        setShareInfo,
        openWebShare,
        setOpenWebShare,
        sharePopupShow,
        setSharePopupShow
    }
    useEffect(() => {
        // console.log(sharePopupShow)
    }, [sharePopupShow])
    return (
        <LiveStreamContext.Provider value={returnValue}>
            <LiveStreamView />
            <SportsLiveTabs />
            <LiveSportsFilterTabs sportsFilter={sportsFilter} setSportsFilter={setSportsFilter} />
            {
                !loading
                    ? mobileMode
                        ? <LiveSportsList list={liveListFilter} />
                        : <LiveSportsListPC list={liveListFilter} />
                    : <Lottie loop animationData={loadingJson} play style={{ maxWidth: `400px`, margin: "0 auto" }} />
            }
            <FloatMultiViewSelect show={multiSelectShow} setShow={setMultiSelectShow} />
            <FloatWebShare />
            {/* 팝업 차단 안내 모달 */}
            <FloatSharePopupMessage show={sharePopupShow} setShow={setSharePopupShow} />
        </LiveStreamContext.Provider>
    )
}
export const useLiveStreamContext = () => useContext(LiveStreamContext)